export type RelatedSearchTile = {
    relatedSearchPages: RelatedSearchPages[];
    relatedSearches: RelatedSearches[];
};

export type RelatedSearches = {
    displayName: string;
    imageUrl: string;
    relatedCategoryId: number;
    url: string;
};

export type RelatedSearchPages = {
    categoryId: number;
    searchTerm: string;
    searchTermSlug: string;
    url: string;
};

export type CategoryRelatedSearchTilesSlice = {
    categoryRelatedSearchTiles: RelatedSearchTile;
};

export const defaultCategoryRelatedSearchTilesSlice: CategoryRelatedSearchTilesSlice = {
    categoryRelatedSearchTiles: {
        relatedSearches: [],
        relatedSearchPages: [],
    },
};
